/**
 * @desc 直发锁定数量
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.cabinMasterFactoryScattered.cabinOccupySkuMpq.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/cabinOccupySkuMpq`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
